import { ReactNode } from 'react'
import { useTenantId, useChannelLoader } from '@/hooks/channelLoader'
import ThemeLoader from '@/components/ThemeLoader'
import StoreNotAvailable from '@/components/StoreNotAvailable'
import GoogleTagManager from '@/components/GoogleTagManager'
import CookieConsentBanner from '@/components/CookieConsentBanner'

interface ChannelGateProps {
  children: ReactNode
}

export default function ChannelGate({ children }: ChannelGateProps) {
  const tenantId = useTenantId()
  const { isLoading, isUnavailable } = useChannelLoader(tenantId)

  if (isLoading) {
    return <ThemeLoader />
  }

  if (isUnavailable) {
    return <StoreNotAvailable />
  }

  return (
    <>
      <GoogleTagManager />
      <CookieConsentBanner />
      {children}
    </>
  )
}
